import NotificationHeader from "./NotificationHeader";

export { NotificationHeader as default };
